import type { ImageMask } from '@ox/schema';

import circle from '../assets/masks/circle.png';
import cloud from '../assets/masks/cloud.png';
import distressed from '../assets/masks/distressed.png';
import distressedH from '../assets/masks/distressed-h.png';
import distressedSquare from '../assets/masks/distressed-square.png';
import flower from '../assets/masks/flower.png';
import heart from '../assets/masks/heart.png';
import label from '../assets/masks/label.png';
import love from '../assets/masks/love.png';
import ovalH from '../assets/masks/oval-h.png';
import ovalV from '../assets/masks/oval-v.png';
import paint from '../assets/masks/paint.png';
import roundedSquare from '../assets/masks/rounded-square.png';
import square from '../assets/masks/square.png';
import star from '../assets/masks/star.png';
import star2 from '../assets/masks/star2.png';
import rect45 from '../assets/masks/rect-4-5.png';
import rect34 from '../assets/masks/rect-3-4.png';
import rect23 from '../assets/masks/rect-2-3.png';
import rect12 from '../assets/masks/rect-1-2.png';
import rect54 from '../assets/masks/rect-5-4.png';
import rect43 from '../assets/masks/rect-4-3.png';
import rect32 from '../assets/masks/rect-3-2.png';
import rect21 from '../assets/masks/rect-2-1.png';
import brush from '../assets/masks/brush.png';

/** Bitmap mask assets (white + alpha). Used by editor CSS/Konva and mirrored on server for print. */
export const MASK_IMAGE_URL: Partial<Record<ImageMask, string>> = {
  circle,
  square,
  'rounded-square': roundedSquare,
  'oval-h': ovalH,
  'oval-v': ovalV,
  cloud,
  flower,
  distressed,
  'distressed-square': distressedSquare,
  'distressed-h': distressedH,
  heart,
  love,
  paint,
  label,
  star,
  star2,
  'rect-4-5': rect45,
  'rect-3-4': rect34,
  'rect-2-3': rect23,
  'rect-1-2': rect12,
  'rect-5-4': rect54,
  'rect-4-3': rect43,
  'rect-3-2': rect32,
  'rect-2-1': rect21,
  brush,
};

export const EDITOR_MASKS: { id: ImageMask; label: string }[] = [
  { id: 'none', label: 'Sin marco' },
  { id: 'circle', label: 'Círculo' },
  { id: 'square', label: 'Cuadrado' },
  { id: 'rounded-square', label: 'Cuadrado redondeado' },
  { id: 'oval-h', label: 'Óvalo' },
  { id: 'oval-v', label: 'Óvalo vertical' },
  { id: 'cloud', label: 'Nube' },
  { id: 'flower', label: 'Flor' },
  { id: 'distressed', label: 'Desgastado' },
  { id: 'distressed-square', label: 'Cuadrado desgastado' },
  { id: 'distressed-h', label: 'Desgastado horizontal' },
  { id: 'heart', label: 'Corazón' },
  { id: 'love', label: 'Love' },
  { id: 'paint', label: 'Pintura' },
  { id: 'label', label: 'Etiqueta' },
  { id: 'star', label: 'Estrella' },
  { id: 'star2', label: 'Estrella 2' },
  { id: 'rect-4-5', label: 'Rectángulo 4:5' },
  { id: 'rect-3-4', label: 'Rectángulo 3:4' },
  { id: 'rect-2-3', label: 'Rectángulo 2:3' },
  { id: 'rect-1-2', label: 'Rectángulo 1:2' },
  { id: 'rect-5-4', label: 'Rectángulo 5:4' },
  { id: 'rect-4-3', label: 'Rectángulo 4:3' },
  { id: 'rect-3-2', label: 'Rectángulo 3:2' },
  { id: 'rect-2-1', label: 'Rectángulo 2:1' },
  { id: 'brush', label: 'Brocha' },
];

export function maskImageUrl(mask: ImageMask | string | undefined): string | undefined {
  if (!mask || mask === 'none') return undefined;
  return MASK_IMAGE_URL[mask as ImageMask];
}
